import { createContext, useContext, useState, ReactNode } from "react";
import { ClassNameType } from "../components/ClassSelector/ClassData";

type BaseContextType = {
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
  selectedClass: ClassNameType[];
  setSelectedClass: (className: ClassNameType[]) => void;
};

const BaseContext = createContext<BaseContextType | undefined>(undefined);

export function BaseProvider({ children }: { children: ReactNode }) {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [selectedClass, setSelectedClass] = useState<ClassNameType[]>([]);

  return (
    <BaseContext.Provider
      value={{
        isModalOpen,
        setIsModalOpen,
        selectedClass,
        setSelectedClass,
      }}
    >
      {children}
    </BaseContext.Provider>
  );
}

export function useBaseContext() {
  const context = useContext(BaseContext);
  if (!context)
    throw new Error("useBaseContext must be used within a BaseProvider");
  return context;
}
